import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-41127d9c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "layout" }
const _hoisted_2 = { class: "layout-head" }
const _hoisted_3 = { class: "user" }
const _hoisted_4 = { class: "avatar f-avatar" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "name" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("收益")
const _hoisted_8 = { class: "layout-body" }
const _hoisted_9 = { class: "layout-foot" }
const _hoisted_10 = { class: "tabs" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("全部通告")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("我的通告")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("收益")
const _hoisted_14 = { class: "about" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "JControl Web", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_dropdown = _resolveComponent("a-dropdown")!
  const _component_Identity = _resolveComponent("Identity")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_a_dropdown, null, {
        overlay: _withCtx(() => [
          _createVNode(_component_a_menu, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_menu_item, null, {
                default: _withCtx(() => [
                  _createElementVNode("div", {
                    class: "menu-item",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showIdentity && _ctx.showIdentity(...args)))
                  }, "我的ID")
                ]),
                _: 1
              }),
              _createVNode(_component_a_menu_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_router_link, {
                    to: { name: 'MyReward' },
                    class: "menu-item"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_7
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_menu_item, null, {
                default: _withCtx(() => [
                  _createElementVNode("div", {
                    class: "menu-item",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.showAbout && _ctx.showAbout(...args)))
                  }, "關於")
                ]),
                _: 1
              }),
              _createVNode(_component_a_menu_item, null, {
                default: _withCtx(() => [
                  _createElementVNode("div", {
                    class: "menu-item",
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)))
                  }, "登出")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("img", {
                src: _ctx.currentUser.avatar
              }, null, 8, _hoisted_5)
            ]),
            _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.currentUser.name), 1)
          ])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_8, [
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_router_link, {
          class: "tab",
          "active-class": "tab--active",
          to: { name: 'AllJobs' }
        }, {
          default: _withCtx(() => [
            _hoisted_11
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          class: "tab",
          "active-class": "tab--active",
          to: { name: 'MyJobs' }
        }, {
          default: _withCtx(() => [
            _hoisted_12
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          class: "tab",
          "active-class": "tab--active",
          to: { name: 'MyReward' }
        }, {
          default: _withCtx(() => [
            _hoisted_13
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode(_component_a_modal, {
      visible: _ctx.isIdentityVisible,
      "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.isIdentityVisible) = $event)),
      footer: "",
      closable: false
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Identity, { onClose: _ctx.hideIdentity }, null, 8, ["onClose"])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_a_modal, {
      visible: _ctx.isAboutVisible,
      "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.isAboutVisible) = $event)),
      footer: ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_14, [
          _hoisted_15,
          _createElementVNode("span", null, "V" + _toDisplayString(_ctx.version), 1)
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}